import React from 'react';
import { IUseEarlyAccess } from '@pro/activity/testerClub/useEarlyAccess';
import ThemeEmpty from '@base/lib/ThemeEmpty';
import ProductM from '@pro/activity/testerClub/Products/ProductM';
import ProductPc from '@pro/activity/testerClub/Products/ProductPc';

type IProps = {
    earlyAccess: IUseEarlyAccess
}

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const Product: React.FC<IProps> = (props) => {

    const { earlyAccess } = props
    const { showLists = {}, tabActivityKey } = earlyAccess

    const showList = showLists?.[tabActivityKey] || []

    return !showList.length ? <ThemeEmpty/> : (
        <>
            {showList?.map((item, index) => {

                if (isPhone) {
                    return <ProductM key={item.activityGid} product={item} earlyAccess={earlyAccess}/>
                }

                return (
                    <ProductPc key={item.activityGid} product={item} earlyAccess={earlyAccess}/>
                )
            })
            }
        </>
    );
};

export default Product